import { guidEmpty } from "utils/guid-empty";

export class PessoaClienteIdealPutModel {
    constructor(
        public pessoaId: string = guidEmpty(),
        public perguntaId: string = guidEmpty(),
        public respostaId: string = guidEmpty(),
    ) { }
}